import React, {Component} from 'react';

import {Button} from '@betareader/design-system';

import {toast} from 'react-toastify';

import {withRouter} from 'react-router-dom';

// i18n
import {withTranslation} from 'react-i18next';

// redux
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {deleteVersion} from '../../modules/book';
import featureToggleUtil from '../../utils/featureToggleUtil';

export class DownloadVersion extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  downloadDocx = async versionId => {
    const {t} = this.props;
    this.setState({
      downloadingDocx: true
    });
    const {idToken, bookId} = this.props;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${bookId}/content/${versionId}?format=docx`,
        {
          method: 'GET',
          headers: {
            'br-token': idToken
          }
        }
      );
      const result = await response.json();
      if (result.url) {
        window.open(result.url);
      } else {
        toast.error(t('DownloadFailedMsg'));
      }
    } catch (e) {
      console.error('failed to download version', e);
      return false;
    } finally {
      this.setState({
        downloadingDocx: false
      });
    }
  };

  downloadTxtFile = csvData => {
    const element = document.createElement('a');
    const file = new Blob([csvData], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = 'feedback.csv';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  downloadMarkdown = async versionId => {
    const {t} = this.props;
    this.setState({downloadingMarkdown: true});
    const {idToken, bookId} = this.props;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${bookId}/content/${versionId}?format=md`,
        {
          method: 'GET',
          headers: {
            'br-token': idToken
          }
        }
      );
      if (!response.ok) {
        toast.error(t('DownloadFailedMsg'));
        return;
      }
      const markdown = await response.text();
      const element = document.createElement('a');
      const file = new Blob([markdown], {type: 'text/markdown'});
      element.href = URL.createObjectURL(file);
      element.download = 'manuscript.md';
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
    } catch (e) {
      console.error('failed to download markdown', e);
      return false;
    } finally {
      this.setState({downloadingMarkdown: false});
    }
  };

  downloadCSV = async versionId => {
    this.setState({
      downloadingCSV: true
    });
    const {idToken, bookId} = this.props;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${bookId}/content/${versionId}?format=csv`,
        {
          method: 'GET',
          headers: {
            'br-token': idToken
          }
        }
      );
      const result = await response.text();
      this.downloadTxtFile(result);
    } catch (e) {
      console.error('failed to download version', e);
      return false;
    } finally {
      this.setState({
        downloadingCSV: false
      });
    }
  };

  render() {
    const {t, content, style = {}, text, markdownExportEnabled} = this.props;
    const {downloadingCSV, downloadingDocx, downloadingMarkdown} = this.state;
    if (!content?.length) return null;

    if (content.length === 1) {
      const versionId = content[0]._id;
      return (
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '.5rem', ...style}}>
          <Button variant='secondary' disabled={downloadingDocx} aria-busy={Boolean(downloadingDocx)}
            onClick={() => this.downloadDocx(versionId)}>{t('DOCX')}</Button>
          <Button variant='secondary' disabled={downloadingCSV} aria-busy={Boolean(downloadingCSV)}
            onClick={() => this.downloadCSV(versionId)}>{t('CSV')}</Button>
          {markdownExportEnabled && (
            <Button variant='secondary' disabled={downloadingMarkdown}
              aria-busy={Boolean(downloadingMarkdown)}
              onClick={() => this.downloadMarkdown(versionId)}>{t('Markdown')}</Button>
          )}
        </div>
      );
    }

    return (
      <details style={style}>
        <summary style={{cursor: 'pointer'}}>{text || t('Download')}</summary>
        <ul style={{listStyle: 'none', padding: 0, margin: '.5rem 0'}}>
          {content.map(version => (
            <li key={version._id}>
              <Button variant='secondary' disabled={downloadingDocx}
                aria-busy={Boolean(downloadingDocx)}
                onClick={() => this.downloadDocx(version._id)}>
                {`${t('PickVersion')} ${version.versionNumber} (${t('DOCX')})`}
              </Button>
            </li>
          ))}
        </ul>
      </details>
    );
  }

}

// redux stuff
const mapStateToProps = state => ({
  idToken: state.user.idToken,
  // Per-user gate for the Markdown export button; the API also enforces the
  // markdown_export flag (global OR per-user) and returns 403 if off.
  markdownExportEnabled: featureToggleUtil.hasFeatureAccess(
    state.user.userProfile,
    'markdown_export'
  )
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      deleteVersion
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DownloadVersion))
);
